import type { FC } from 'react';
import { useCallback, useMemo } from 'react';
import { selectSportFavoritesSetV2 } from '@mwl/core-lib';
import { useMediaWidthDown, useTypedSelector } from '@/hooks';
import { MatchCompetitors } from '../MatchCompetitors/MatchCompetitors';
import { MatchInfoDesktop } from '../MatchInfoDesktop/MatchInfoDesktop';
import { MatchInfoMobile } from '../MatchInfoMobile/MatchInfoMobile';
import type { MatchInfoProps } from './MatchInfo.types';
export const MatchInfo: FC<MatchInfoProps> = ({
  line,
  className
}) => {
  const isXsScreen = useMediaWidthDown('screen850');
  const favorites = useTypedSelector(selectSportFavoritesSetV2);
  const isFavorite = useMemo(() => favorites.lineIds.has(line.id), [favorites.lineIds, line.id]);
  const competitors = useCallback((isSmallSize?: boolean) => <MatchCompetitors line={line} mobileSize={isSmallSize ? 'small' : 'normal'} />, [line]);
  if (isXsScreen) {
    return <MatchInfoMobile renderCompetitors={competitors} line={line} className={className} isFavorite={isFavorite} />;
  }
  return <MatchInfoDesktop renderCompetitors={competitors} line={line} className={className} isFavorite={isFavorite} data-sentry-element="MatchInfoDesktop" data-sentry-component="MatchInfo" data-sentry-source-file="MatchInfo.tsx" />;
};